import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "mkxjYi",
    defaultMessage: "Shipping",
    description: "wizard step title",
  },
  description: {
    id: "LC7x2Z",
    defaultMessage:
      "Set up a shipping zone to define where and how you ship products.",
    description: "wizard step description",
  },
  successMessage: {
    id: "wAw0HM",
    defaultMessage: "Shipping zone created",
    description: "wizard step success notification",
  },
  errorMessage: {
    id: "BJau+m",
    defaultMessage: "Failed to create shipping zone",
    description: "wizard step error notification",
  },
  zoneName: {
    id: "DWmkBy",
    defaultMessage: "Shipping Zone Name",
    description: "form field label",
  },
  zoneNameHelper: {
    id: "qDNqH0",
    defaultMessage: "e.g., 'Domestic', 'United States', 'International'",
    description: "form field helper text",
  },
  zoneDescription: {
    id: "LP62SP",
    defaultMessage: "Description",
    description: "form field label",
  },
  countriesTitle: {
    id: "imoPq/",
    defaultMessage: "Countries",
    description: "form section title",
  },
  countriesDescription: {
    id: "yAG4Wk",
    defaultMessage: "Select countries included in this shipping zone",
    description: "form section description",
  },
  shippingAppsTitle: {
    id: '6JdIrl',
    defaultMessage: "Shipping Apps",
    description: "section title for shipping app configuration",
  },
  shippingAppsDescription: {
    id: 'WruteT',
    defaultMessage:
      "Configure your installed shipping carrier integrations.",
    description: "section description for shipping apps",
  },
  noShippingApps: {
    id: 'domWgp',
    defaultMessage:
      "No supported shipping apps are installed. You can install and configure shipping apps later from the Extensions section.",
    description: "empty state text when no shipping apps found",
  },
});
